module.exports = __webpack_public_path__ + "static/media/custom-checkbox-modern-1-unchecked.fbd2d63e.svg";